import Profile from '@views/Profile';
import { useGetUserDetailsV1 } from '@services/cd4pe/users';
import PageLoader from '@components/PageLoader';
import React from 'react';
import { useAppSelector } from '@hooks/redux';
import { Alert } from '@puppet/react-components';
import { selectUser } from '@state/session/selectors';
import { useParams } from 'react-router-dom';
import { BreadcrumbsType } from '@components/Breadcrumbs/Breadcrumbs';
import { useTranslation } from 'react-i18next';
import Cd4peError from '@components/Cd4peError';
import { UserV1 } from '@puppet/cd4pe-client-ts';
import { LINKS } from '../../routes';

const RootViewProfile = () => {
  const { domain } = useAppSelector(selectUser) as UserV1;
  const { id: userId } = useParams<{ id: string }>();
  const { t } = useTranslation('codeDelivery');

  const userIdNumber = Number(userId);

  const { data, isLoading, error } = useGetUserDetailsV1({
    userId: userIdNumber,
    workspaceId: domain!,
  });

  if (isLoading) {
    return <PageLoader />;
  }

  const selectedUser = data?.user;

  if (error) {
    return <Cd4peError error={error} />;
  }

  if (!selectedUser) {
    return (
      <div className="root-profile-view-error-container">
        <Alert type="danger">{t('root.accounts.profile.error')}</Alert>
      </div>
    );
  }

  const breadcrumbs: BreadcrumbsType = [
    {
      displayName: t('root.accounts.breadcrumbs.root.console'),
    },
    {
      displayName: t('root.accounts.breadcrumbs.root.accounts'),
      linkDestination: LINKS.root.accounts,
    },
    {
      displayName: selectedUser.userName ?? '',
    },
  ];

  return <Profile user={selectedUser} breadcrumbs={breadcrumbs} />;
};

export default RootViewProfile;
